import { ArtButton } from "components/button";
import { TextInput } from "components/input/text-input";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, ui, utils } from "services";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const onSubmit = (e: any) => {
    e.preventDefault();
    const isValid = utils.isValidEmail(email);
    if (!isValid) {
      setErr("Invalid email");
      return;
    }
    setLoading(true)
    api.forgotPassword(email).then((data) => {
      ui.alertSuccess("Check your email to reset password", "");
      setEmail("");
      setErr("");
      setLoading(false);
    }).catch(err => {
      ui.alertFailed("Request failed !", "Please try again later !");
      setLoading(false);
    })
  }

  return (
    <div className="w-full dao-container">
      <div className="w-full w-full modal fixed w-full h-full top-0 left-0 flex items-center justify-center">
        <form className="shadow-md border border-black rounded px-8 py-8 pb-12 mb-4 w-[480px] bg-black-secondary">
          <div className="text-2xl text-white font-semibold text-center mb-6">
            Forgot password
          </div>
          <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-8" />
          <div className="">
            <span className="block text-sm font-semibold mb-2 text-white">
              Type your email to reset password
            </span>
            <TextInput
              type="email"
              fieldName={"Email"} value={email} setValue={setEmail}
              setErr={setErr}
            />
          </div>
          <div className="gap-4 mt-6 mx-auto flex">
            <ArtButton
              className="text-white font-bold w-full py-2 rounded"
              color="red"
              onClick={() => { nav('/') }}
            >Cancel</ArtButton>

            <ArtButton
              className="text-white font-bold w-full py-2 rounded"
              color="yellow"
              loading={loading}
              disabled={!!err || !email || loading}
              onClick={onSubmit}
            >Submit</ArtButton>
          </div>
        </form>
      </div >
    </div >
  )
}
